import * as yup from "yup";

const isRequiredMessage = "Completa este campo";

export default yup.object().shape({
  documento: yup.string().required(isRequiredMessage).max(50),
});


